// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hKgf","largestCol":"styles_largestCol__1EL67","smallestCol":"styles_smallestCol__3VPoL"};